<!-- Components for datepicker tag    -->

<script>
import { services } from '@src/utils/common-services'

export default {
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  // components: { VueTimepicker },
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,

  model: {
    event: 'update',
  },
  props: {
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    options: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      type: Object,
      default() {
        return null
      },
    },

    label: {
      type: String,
      default() {
        return ''
      },
    },
    form: {
      type: String,
      default() {
        return ''
      },
    },
    name: {
      type: String,
      default: 'name',
    },
    type: {
      type: String,
      default() {
        return 'date'
      },
    },
    // Only allow types that essentially just render text boxes.
  },
  data() {
    return {
      data: {},
      start_time: '',
      end_time: '',
      error: null,
      selected: [], // Must be an array reference!
      option: [
        { text: 'Mon', value: 'Mon' },
        { text: 'Tue', value: 'Tue' },
        { text: 'Wed', value: 'Wed' },
        { text: 'Thu', value: 'Thu' },
        { text: 'Fri', value: 'Fri' },
        { text: 'Sat', value: 'Sat' },
        { text: 'Sun', value: 'Sun' },
      ],
    }
  },
  computed: {
    validationNotBefore() {
      return this.options.validationNotBefore !== undefined
        ? services.findDate(this.options.validationNotBefore)
        : services.findDate(-100)
    },
    validationNotAfter() {
      return this.options.validationNotAfter !== undefined
        ? services.findDate(this.options.validationNotAfter)
        : services.findDate(0)
    },
  },

  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.value !== null) {
          if (
            this.value.hours !== undefined &&
            this.value.hours.start_time !== undefined
          )
            this.start_time = this.value.hours.start_time
          if (
            this.value.hours !== undefined &&
            this.value.hours.end_time !== undefined
          )
            this.end_time = this.value.hours.end_time
          if (this.value.days !== undefined) this.selected = this.value.days
        }
      }
    },
    selected(newVal, oldVal) {
      if (newVal !== oldVal) this.sendData()
    },
    start_time(newVal, oldVal) {
      if (newVal !== oldVal) this.sendData()
    },
    end_time(newVal, oldVal) {
      if (newVal !== oldVal) this.sendData()
    },
  },
  mounted() {
    if (this.value !== null) {
      if (
        this.value.hours !== undefined &&
        this.value.hours.start_time !== undefined
      )
        this.start_time = this.value.hours.start_time
      if (
        this.value.hours !== undefined &&
        this.value.hours.end_time !== undefined
      )
        this.end_time = this.value.hours.end_time
      if (this.value.days !== undefined) this.selected = this.value.days
    }
  },

  methods: {
    sendData() {
      // EventBus.$emit('testEvent', 'test')

      var working = {}

      working['hours'] = {
        start_time: this.start_time,
        end_time: this.end_time,
      }
      working['days'] = this.selected
      // console.log(working)
      if (
        working.days.length === 0 ||
        this.start_time === '' ||
        this.start_time === null ||
        this.end_time === null ||
        this.end_time === ''
      ) {
        this.error = 'Please fill all fileds'
        this.$emit('update', null)
      } else {
        this.$emit('update', working)
        this.error = null
      }
    },
  },
}
</script>

<template>
  <div :class="$style.formGroup" class="formGroup mt20 mt10-sm">
    <div class="formFieldWrap">
      <label :class="$style.fieldTitle" class="w40 w100-sm FL pr15 pr0-sm">{{
        label
      }}</label>
      <div class="form-field w60 w100-sm FL">
        <div :class="$style.inputField">
          <ValidationProvider
            v-slot="{ errors }"
            mode="passive"
            :vid="name + 'start'"
            :name="name + 'start'"
            :validation="{ required: true }"
          >
            <!--  <VueTimepicker
              v-model="start_time"
              placeholder="Start Time"
              format="hh:mm a"
              :name="name + 'start'"
              close-on-complete
            ></VueTimepicker> -->
            <span v-show="errors[0]" :class="$style.error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
          <span> to </span>
          <ValidationProvider
            v-slot="{ errors }"
            mode="passive"
            :vid="name + 'to'"
            :name="name + 'to'"
            :validation="{ required: true }"
          >
            <!--  <VueTimepicker
              v-model="end_time"
              :name="name + 'to'"
              placeholder="End Time"
              format="hh:mm a"
              class="mt10"
              close-on-complete
            ></VueTimepicker> -->
            <span v-show="errors[0]" :class="$style.error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="clear"></div>
      <div :class="$style.checkBoxWrap">
        <b-form-group>
          <b-form-checkbox-group
            v-model="selected"
            :options="option"
            buttons
            button-variant="primary"
            size="md"
            name="buttons-2"
          >
          </b-form-checkbox-group>
        </b-form-group>
        <span v-if="error !== null" :class="$style.error">{{ error }}</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.formGroup {
  max-width: 500px;
}
.checkBoxWrap {
  position: relative;
  padding: 20px 10px;
  margin-top: 10px;
  text-align: center;
  background: #fafafa;
  border-radius: 10px;

  label {
    margin-right: 10px !important;
    font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 14px;
    color: #3c9cee;
    background: #fff;
    border-radius: 5px !important;

    &:focus {
      color: #3c9cee;
      background: #fff;
    }
  }

  fieldset {
    margin: 0 !important;
  }
}

@media (max-width: 767px) {
  .checkBoxWrap {
    text-align: left;
    label {
      margin-bottom: 5px !important;
    }
  }
}
</style>
